import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createBrand,
  getBrands,
  getBrandById,
  updateBrand,
  deleteBrand,
} from "../api/brand";

// Brand Hooks
export const useCreateBrand = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => createBrand(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["brands"]);
    },
  });
};

export const useGetBrands = () => {
  return useQuery({
    queryKey: ["brands"],
    queryFn: () => getBrands(),
    refetchOnWindowFocus: false,
  });
};

export const useGetBrandById = (id) => {
  return useQuery({
    queryKey: ["brand", id],
    queryFn: () => getBrandById(id),
    enabled: !!id,
  });
};

export const useUpdateBrand = (id) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => updateBrand(data),
    onSuccess: () => {
      queryClient.invalidateQueries(["brands"]);
    },
  });
};

export const useDeleteBrand = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteBrand(id),
    onSuccess: () => {
      queryClient.invalidateQueries(["brands"]);
    },
  });
};